export default __webpack_public_path__ + "static/O0051-84473ffe5d5990bb10369f477e387b8b.png";